export const EXTERNAL_ACCESS_TOKEN_HEADER = 'external_sso_access_token';
export const SOURCE_API_HEADER = 'sourceApi';